<script>
import Layout from "../../layouts/auth";
import {authMethods} from "@/state/helpers";
import appConfig from "@/app.config";

import {required} from "vuelidate/lib/validators";
import axios from "axios";

import Validation_errors from "@/components/validation_errors";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Reset Password",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Validation_errors, Layout},
  mounted() {
    if (!this.$route.query.token || !this.$route.query.email) {
      this.isResetError = true;
      this.error = 'token or email missing';
      this.errorVariant = 'danger';
    } else
      this.canSubmit = true;
  },
  data() {
    return {
      password: "",
      password_confirmation: "",
      submitted: false,
      canSubmit: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      errorVariant: 'danger',
      apiReturn: null,
      email: this.$route.query.email,
      token: this.$route.query.token,
      submitSuccess: false
    };
  },
  validations: {
    password: {required},
    password_confirmation: {
      required, notmatch: function () {
        return this.password === this.password_confirmation;
      }
    },

  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      if (!this.canSubmit) {
        this.isResetError = true;
        this.errorVariant = 'danger';
        return;
      }

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.tryingToReset = true;
        // Reset the authError if it existed.
        this.error = null;
        this.submitSuccess = false;

        axios.post('/api/reset-password', {
          password: this.password,
          password_confirmation: this.password_confirmation,
          email: this.email,
          token: this.token,
        })
            .then(response_login => {
              response_login;
              this.tryingToReset = false;

              if (response_login.data.error === true) {
                this.isResetError = true;
                this.error = response_login.data;
                this.errorVariant = 'danger';
                this.apiReturn = response_login.data;
                return;
              }

              this.isResetError = false;
              this.submitSuccess = true;
            })
            .catch(error => {
              this.tryingToReset = false;
              this.isResetError = true;
              this.errorVariant = 'danger';
              this.error = error ? error : "";

              this.apiReturn = error.response.data;

            });
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-pink">
            <div class="row">
              <div class="col-7">
                <div class="text-pink p-4">
                  <h5 class="text-pink">Reset Password</h5>
                  <p>Re-Password with RADIS TECH.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.png" alt height="34"/>
                  </span>
                </div>
              </router-link>
            </div>
            <div class="p-2">
              <b-alert v-model="isResetError" class="mb-4" :variant="errorVariant" dismissible>
                <Validation_errors :errors="apiReturn"></Validation_errors>
              </b-alert>
              <div v-if="submitSuccess" class="mb-4 alert alert-success">
                Mot de passe réinitialisé avec succès, vous pouvez vous <a href="/login">connecter</a>
              </div>
              <form @submit.prevent="tryToReset" v-if="!submitSuccess">
                <div class="form-group">
                  <label for="password">Password</label>
                  <input
                      type="password"
                      v-model="password"
                      class="form-control"
                      id="password"
                      :class="{ 'is-invalid': submitted && $v.password.$error }"
                  />
                  <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                    <span v-if="!$v.password.required">Password is required.</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="password_confirmation">Retype password</label>
                  <input
                      type="password"
                      v-model="password_confirmation"
                      class="form-control"
                      id="password_confirmation"
                      :class="{ 'is-invalid': submitted && $v.password_confirmation.$error }"
                  />
                  <div v-if="submitted && $v.password_confirmation.$error" class="invalid-feedback">
                    <span v-if="!$v.password_confirmation.required">Password is required.</span>
                    <span v-if="!$v.password_confirmation.notmatch">Passwords not match.</span>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-pink w-md" type="submit">Reset</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} RADIS TECH<!--. Crafted with
            <i
              class="mdi mdi-heart text-danger"
            ></i> by Themesbrand-->
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
